<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户/供应商管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/client' }">客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}客户</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">基础信息</div>
        <el-form-item label="客户公司名称：" prop="company">
          <el-col style="width: 600px;">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.company" clearable />
          </el-col>
        </el-form-item>
        <!-- 可重复部分 -->
        <template>
          <ul class="anlist">
            <li v-for="(item, index) in form.brandList" :key="index">
              <div class="abox">
                <el-form-item :label="`品牌:`" prop="brand">
                  <el-col style="width: 600px;">
                    <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="item.brand" clearable />
                  </el-col>
                </el-form-item>
                <div class="abox_pin">
                  <el-form-item :label="`联系人姓名:`" prop="name">
                    <el-col style="width: 450px;">
                      <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="item.name" clearable />
                    </el-col>
                  </el-form-item>
                  <el-form-item :label="`联系人电话:`" prop="phone">
                    <el-col style="width: 450px;">
                      <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="item.phone" clearable />
                    </el-col>
                  </el-form-item>
                  <el-form-item :label="`联系人邮箱:`" prop="email">
                    <el-col style="width: 450px;">
                      <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="item.email" clearable />
                    </el-col>
                  </el-form-item>
                </div>
              </div>
              <el-button class="abtn" icon="el-icon-minus" @click="removeOption(form.brandList, index)"
                circle></el-button>
            </li>
            <el-button type="primary" class="addbtn" @click="addOption(form.brandList)">新增品牌</el-button>
          </ul>
        </template>

        <el-form-item label="公司地址：" prop="work_address">
          <el-col style="width: 600px;">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.work_address" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="备注：" prop="info">
          <el-col style="width: 600px;">
            <el-input style="width: 100%;" type="textarea" spellcheck="false" :autosize="{ minRows: 4 }"
              placeholder="请输入内容" v-model="form.info">
            </el-input>
          </el-col>
        </el-form-item>

        <div class="formtitle">付款信息</div>
        <el-form-item label="付款账户：" prop="pay_company">
          <el-col style="width: 600px;">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.pay_company" clearable />
          </el-col>
        </el-form-item>
        <el-form-item label="银行名称：" prop="pay_bank">
          <el-col style="width: 600px;">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.pay_bank" clearable />
          </el-col>
        </el-form-item>
        <el-form-item label="银行账号：" prop="pay_bank_account">
          <el-col style="width: 600px;">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.pay_bank_account" clearable />
          </el-col>
        </el-form-item>

        <div class="formtitle">工商信息</div>
        <el-form-item label="统一社会信用代码：" prop="company_id_card">
          <el-col style="width: 600px;">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.company_id_card" clearable />
          </el-col>
        </el-form-item>
        <el-form-item label="公司注册地址：" prop="reg_address">
          <el-col style="width: 600px;">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.reg_address" clearable />
          </el-col>
        </el-form-item>
        <el-form-item label="公司电话：" prop="company_phone">
          <el-col style="width: 600px;">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.company_phone" clearable />
          </el-col>
        </el-form-item>

        <template>
          <ul class="anlist">
            <li v-for="(item, index) in fileList" :key="index">
              <div class="abox">
                <el-form-item :label='`附件${index + 1}：`'>
                  <!-- 选择文件 -->
                  <el-col :span="3">
                    <el-upload class="upload-demo" ref="upFile" action="#" :limit="1" :show-file-list="false"
                      :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                      :on-change="(arg) => uploadFile(arg, item, index)">
                      <el-button size="small" style="width: 100%">选择文件</el-button>
                    </el-upload>
                  </el-col>
                  <!-- 文件预览及下载 -->
                  <template v-if="item.origin_name">
                    <el-col :span="10">
                      <el-col :span="18">
                        <div class="origin-name">{{ item.origin_name }}</div>
                      </el-col>
                      <el-col :span="4">
                        <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                          target="_blank">查看</el-link>
                      </el-col>
                    </el-col>
                  </template>
                </el-form-item>
              </div>
              <el-button class="bbtn" icon="el-icon-minus" @click="removeImage(fileList, index)"
                circle></el-button>
            </li>
            <el-button type="primary" style="margin: 0 0 15px 150px;" class="addbtn" @click="addImage(fileList)">新增附件</el-button>
          </ul>
        </template>

        <el-form-item label="">
          <el-col>
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>

    <el-dialog :title="popTitle" :visible.sync="dialogVisible" :show-close="false" width="30%">
      <span>{{ popMessage }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import * as api from '@/api'
export default {
  name: 'clientdetail',
  data() {
    return {
      nodeLimtList: [],
      popTitle: '提示标题',
      popMessage: '提示内容',
      dialogVisible: false,
      form: {
        client_id: '',
        company: '',
        brand_str: '',
        brandList: [
          {
            brand_id: 0,
            brand: '',
            name: '',
            phone: '',
            email: '',
          }
        ],
        work_address: '',
        info: '',
        pay_company: '',
        pay_bank: '',
        pay_bank_account: '',
        company_id_card: '',
        reg_address: '',
        company_phone: '',
        atta_str: {},
        option: '',
      },
      del_list: [],
      p: 1,
      type: 0,
      rules: {
        company: [
          {
            required: true,
            message: '请输入客户公司名称',
            trigger: 'change',
          },
        ],
        pay_company: [
          {
            required: true,
            message: '请输入付款账户',
            trigger: 'change',
          },
        ],
        pay_bank: [
          {
            required: true,
            message: '请输入银行名称',
            trigger: 'change',
          },
        ],
        pay_bank_account: [
          {
            required: true,
            message: '请输入银行账号',
            trigger: 'change',
          },
        ],
        company_id_card: [
          {
            required: true,
            message: '请输入统一社会信用代码',
            trigger: 'change',
          },
        ],
      },
      fileList: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      del_atta_list: [],
    }
  },
  created() {
    // console.log(this.$route)
    this.query = this.$route.query
    this.query.id && this.getDetail(this.query.id)
    !this.query.id && this.checkUrlFn()
  },

  watch: {
    ['form.pay_bank_account'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.pay_bank_account = val.replace(/\D/g, '').replace(/....(?!$)/g, '$& ');
        });
      }
    },
    ['form.company_phone'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.company_phone = val.replace(/\D/g, '');
        });
      }
    },
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    addOption(arr) {
      arr.push({
        brand_id: 0,
        brand: '',
        name: '',
        phone: '',
        email: '',
      });
    },
    removeOption(arr, index) {
      this.del_list.push(arr[index].id);
      console.log(this.del_list);
      arr = arr.splice(index, 1);
    },
    addImage(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', id: '', flist: []
      });
    },
    removeImage(arr, index) {
      if (arr[index].id) {
        this.del_atta_list.push(arr[index].id);
      }
      console.log(this.del_atta_list);
      arr = arr.splice(index, 1);
    },
    async getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      this.$fly
        .post('apiSale_getClientDetail.html', {
          client_id: id,
        })
        .then((res) => {
          let form = res.itemArr
          this.fileList = res.itemArr.fileList.map((item) => {
            delete item.client_id
            delete item.create_time
            item.flist = []
            return item
          })
          //防空情况       
          if (this.fileList.length === 0) {
            this.fileList = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
          }
          return (this.form = form)
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateClient()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addUpdateClient() {
      this.form.client_id = this.query.id || ''
      this.form.option = this.form.id ? '2' : '1'
      //替换掉id为brand_id
      const $brandList = this.form.brandList.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['brand_id'] = item[key]
            console.log(item['brand_id']);
            delete item[key]
          }
        })
        return item
      })
      this.form.brandList = $brandList
      //替换掉id为file_id
      let fileList = this.fileList.map((item) => {
        delete item.flist
        delete item.httpFile
        return item
      })
      const $fileList = fileList.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['file_id'] = item[key] || 0
            console.log(item['file_id']);
            delete item[key]
          }
        })
        return item
      })
      fileList = $fileList
      this.$fly
        .post('apiSale_addUpdateClient.html', {
          ...this.form,
          brand_str: JSON.stringify(this.form.brandList),
          brand_del: this.del_list.toString(),
          atta_str: JSON.stringify(fileList),
          atta_del: this.del_atta_list.toString(),
        })
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          this.$router.go(-1)
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
    //选择文件
    uploadFile(file, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 1);
      api.uploadFile(formData)
        .then((res) => {
          this.fileList[index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile,
          }
          console.log(this.fileList);

          this.$forceUpdate()
          this.$refs.upFile[index].clearFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abox {
          .abox_pin {
            padding-left: 150px;
          }
        }

        .abtn {
          position: absolute;
          top: 0;
          left: 800px;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 800px;
        }
      }

      .addbtn {
        margin-bottom: 18px;
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }
}
</style>
